var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isJson)?_c('vue-json-pretty',{attrs:{"deep":_vm.expand?Infinity:0,"showLine":false,"showLength":"","data":_vm.jsonData}}):_c('pre',{staticStyle:{"font-size":"14px","color":"black","padding-top":"10px","font-family":"monospace","white-space":"pre-wrap","word-wrap":"break-word"}},[_vm._v(_vm._s(_vm.text))])
}
var staticRenderFns = []

export { render, staticRenderFns }